<img
  *ngIf="isBackgroundImage"
  sizes="100vw"
  srcset="{{background.value}} 2000w, {{background.value}} 1200w, {{background.value}} 600w, {{background.value}} 300w"
  src="{{ background.value }}"
  alt=""
  class="elm-app-background-image"
/>
